interface OrderLoaderProps {
  className?: string;
}

const OrderLoader: React.FC<OrderLoaderProps> = ({ className = '' }) => {
  return (
    <div className={`px-4 md:px-6 lg:px-11 ${className}`.trim()}>
      <div className="animate-pulse rounded border border-neutral-200 bg-neutral-100 p-4">
        <div className="mb-2 h-4 w-1/3 rounded bg-neutral-300" />
        <div className="h-4 w-1/2 rounded bg-neutral-300" />
      </div>
    </div>
  );
};

export default OrderLoader;
